<script>
	import { fly,fade } from 'svelte/transition';
	import { Icon } from '../feathericons.js';

</script>

<div out:fade>
<h3>Welcome to South Cams</h3>
<p>This micro-site holds information about some of the villages and towns in the south cambridgeshire area</p>
<p>To get started explore the above map and click on the markers to find out more information</p>

<h3>Key</h3>
<p>{@html Icon("smile","small")} Playground</p>
<p>{@html Icon("award","small")} Food and Drink</p>
<p>{@html Icon("map","small")} Walks</p>
<p>{@html Icon("gift","small")} Shops</p>
<p>{@html Icon("star","small")} Attractions</p>
<p>{@html Icon("edit-3","small")} Noteworthy Places</p>

</div>
